angular.module('avant.customer_applications.directives').directive 'amountDisabled', [
  'AmountHelper', (AmountHelper) ->
    criteria =
      always:
        if_preapproved: 'disablePreapproved'
        disableSSN: 'disableSSN'
      filled:
        is_post_lead: 'disablePostLead'

    return {
      restrict: 'A'
      require: 'ngModel'
      link: (scope, element, attributes, ngModel) ->

        criterion = attributes.ngModel &&
                    scope.requirements?[attributes.ngModel]?.disabled ||
                    attributes.amountDisabled

        if criterion

          if criterion of criteria.always
            scope.$watch criteria.always[criterion], (disabled) ->
              attributes.$set 'disabled', disabled || null

          else if criterion of criteria.filled
            scope.$watch criteria.filled[criterion], (if_filled) ->
              disabled = if_filled && AmountHelper.notNull(ngModel.$modelValue)
              attributes.$set 'disabled', disabled || null

          else if criterion is true
            attributes.$set 'disabled', true
    }
]
